import dom_ready from "../tools/dom-ready";

let elements;

const dom_elements = dom_ready().then(() => {

    elements = {
    
        window :        window,
        html :          document.documentElement,
        body :          document.body,
    
    };
    
    elements.header =           document.body.querySelector('header');
    elements.main =             document.body.querySelector('main');
    elements.footer =           document.body.querySelector('footer');
    // elements.sections =         elements.main.querySelector(':scope > section');
    // elements.sectionTitles =    elements.sections.querySelector('h2');

    return elements;

})

export default dom_elements;